import { getHostApis } from './getHost'

export function getSearchEngineConfig():
  | Promise<Shift.ShiftSearchEngineConfig>
  | undefined {
  const { shift } = getHostApis()
  return shift?.search?.getDefault?.()
}
